import React from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { PapiUser, PapiGallection } from '@wix/da-types-papi';
import EditConfigButton from '../../../UserWidgets/_partials/WidgetEditControls/EditConfigButton';
import MediaManager from '@wix/da-shared-react/pkg/MediaPopup/MediaManager';
import { GallectionType } from '../../../../../types/gallection';
import { AppState } from '../../../../../types/store';
import { MediaSourceType } from '@wix/da-shared-react/pkg/MediaPopup/types';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../../selectors/users';
import { getGallectionSectionType } from '../../../../selectors/gallectionSection';
import Modal from 'react-modal';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';

import s from './EditGallectionButton.scss';

interface Props {
  gallectionType: GallectionType;
  profileOwnerUser: PapiUser;
  isCurrentUserProfileOwner: boolean;
  gallection?: PapiGallection;
  className?: string;
}

interface State {
  showMediaManager: boolean;
  isReloading: boolean;
}

const defaultState = {
  showMediaManager: false,
  isReloading: false,
};

class EditGallectionButton extends React.Component<Props, State> {
  state: State = defaultState;
  render() {
    if (!this.props.isCurrentUserProfileOwner) {
      return null;
    }
    return (
      <>
        <EditConfigButton
          className={this.props.className}
          onClick={() => this.setState({ showMediaManager: true })}
        />
        {this.state.showMediaManager && (
          <MediaManager
            initialMediaSource={
              this.props.gallectionType === 'gallery'
                ? MediaSourceType.GALLERY
                : MediaSourceType.COLLECTION
            }
            gallectionFolder={this.props.gallection}
            onClose={this.closeAndReload}
            onDone={this.closeAndReload}
          />
        )}
        {this.state.isReloading && (
          <Modal
            isOpen
            className="override"
            overlayClassName={s['reload-overlay']}
          >
            <LoadingIndicator coverMode withOverlay={true} view="daSymbol" />
          </Modal>
        )}
      </>
    );
  }
  closeAndReload = event => {
    this.setState({
      showMediaManager: false,
      isReloading: true,
    });
    event && event.preventDefault();

    // This should be a simple reload, but that
    // doesn't set the referrer on Firefox
    window.location.href = window.location.href;
  };
}

type StateProps = Pick<
  Props,
  'gallectionType' | 'profileOwnerUser' | 'isCurrentUserProfileOwner'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  gallectionType: getGallectionSectionType(state),
  profileOwnerUser: getProfileOwnerUser(state),
  isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
});

export default connect(mapStateToProps)(EditGallectionButton);
